import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { DialogTitleWithClose } from '../../common';

/**
 * RollbackVersionDialog Component
 * Dialog for rolling back to a specific version
 */
const RollbackVersionDialog = ({
  open,
  onClose,
  onConfirm,
  version,
  loading,
}) => {
  const handleConfirm = async () => {
    const success = await onConfirm(version.version);
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitleWithClose
        title="Rollback to Version"
        onClose={onClose}
        disableClose={loading}
      />
      <DialogContent>
        <Typography>
          Are you sure you want to rollback to this version? This will create a
          new version based on the selected version.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : 'Rollback'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RollbackVersionDialog;
